import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "default-navigation",
  class: "uk-nav uk-flex uk-flex-middle uk-margin-remove"
}
const _hoisted_2 = { class: "uk-margin-small-right" }
const _hoisted_3 = { class: "uk-margin-small-right" }
const _hoisted_4 = {
  key: 0,
  class: "uk-margin-small-right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", _hoisted_2, [
      _createVNode(_component_router_link, {
        id: "templates-link",
        to: "/templates"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('header.navigation.templates')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("li", _hoisted_3, [
      _createVNode(_component_router_link, {
        id: "surveys-link",
        to: "/surveys"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('header.navigation.surveys')), 1)
        ]),
        _: 1
      })
    ]),
    (_ctx.canManageUsers)
      ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
          _createVNode(_component_router_link, {
            id: "users-link",
            to: "/users"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('header.navigation.users')), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}